import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Register, RouterProvider } from "@tanstack/react-router";
import { ThemeProvider } from "./components/theme-provider";
import { useAuthenticated } from "./hooks/use-authenticated";
import { RouterDevTools } from "./devtools/router.devtools";
import { QueryDevTools } from "./devtools/query.devtools";
import { PropsWithChildren } from 'react';

const queryClient = new QueryClient();

  export function App({
    router,
    children,
  }: PropsWithChildren<{
    router: Register["router"];
  }>) { 
    useAuthenticated();
    return (
      <ThemeProvider defaultTheme="system" storageKey="theme">
        <QueryClientProvider client={queryClient}>
          {children}
          <RouterProvider router={router} notFoundMode="root" />
          <RouterDevTools router={router} />
          <QueryDevTools client={queryClient} />
        </QueryClientProvider>
      </ThemeProvider>
    );
}
